// extracted by mini-css-extract-plugin
export var avatar = "_pr-3";
export var avatarContainer = "_pr-2";
export var avatarSpacer = "_pr-5";
export var avatarSpacerContainer = "_pr-4";
export var avatarStackContainer = "_pr-1";
export var bubble = "_pr-0";
export var remainderBubble = "_pr-6";